// Based on TiMessengerTestTreiber.yaml 2.0.0
/**
 * A stage in an authentication flow
 */
export type AuthStageName = 'basicAuth';

export const AuthStageName = {
  BasicAuth: 'basicAuth' as AuthStageName
};
